import {RunsDataQuery} from '../../../containers/RunsDataLoader';
import * as Filter from '../../../util/filters';
import {sortToOrderString} from '../../../util/queryts';
import {SingleQuery} from './../../../util/queryTypes';

export type BucketedQueryType =
  | 'BucketedQuery'
  | 'BucketedQueryWithInternalId'
  | 'GroupedBucketedQuery'
  | 'GroupedBucketedQueryWithInternalId';

export function queryVars(
  runsDataQuery: Exclude<RunsDataQuery, 'queries'>,
  query: SingleQuery,
  nBuckets: number,
  queryType: BucketedQueryType,
  expressions: string[] | undefined
) {
  const filters = JSON.stringify(Filter.toMongo(query.filters));
  const order = sortToOrderString(query.sort);

  let limit = runsDataQuery.page?.size || 10;
  if (Array.isArray(limit)) {
    console.error('Unexpected query limit of type array', {
      entityName: runsDataQuery.entityName,
      projectName: runsDataQuery.projectName,
    });
    limit = limit.flat(Infinity)[0] ?? 10;
  }

  // Filter out config.None because it's not a valid group key when grouping in the backend
  // This happens when selecting "None" in the group by dropdown
  // TODO: Move this filtering upstream to where groupKeys are initially populated, once we have sufficient test
  // coverage to safely make that change.
  const groupKeys =
    queryType === 'GroupedBucketedQuery'
      ? runsDataQuery.groupKeys?.filter(k => k !== 'config.None') ?? []
      : [];

  return {
    bucketedHistorySpecs:
      runsDataQuery.bucketedHistorySpecs?.map(bhs =>
        JSON.stringify({...bhs, bins: nBuckets, xAxis: bhs.xAxis ?? '_step'})
      ) ?? [],
    configKeys: runsDataQuery.configKeys,
    enableBasic: true,
    enableConfig: runsDataQuery.configKeys != null,
    enableSummary: runsDataQuery.summaryKeys != null,
    entityName: runsDataQuery.entityName,
    filters,
    groupKeys,
    groupLevel: 0,
    internalId: query.internalProjectId ?? '',
    limit: runsDataQuery.page?.size || 10,
    order,
    projectName: runsDataQuery.projectName,
    summaryKeys: runsDataQuery.summaryKeys,
    expressions,
  };
}
